import { Controller } from "@hotwired/stimulus"
import locales from '../swal-translations/locales.json';
import AlertPopup from "../alert-popup";

const defaultLang = 'it'

export default class extends Controller {
  locale = locales[this.element.dataset.locale||defaultLang]

  confirmDelete(event){
    let tl = this.locale.delete;
    let requestedUrl = this.element.href;

    event.preventDefault()

    const alert = new AlertPopup({
      title:          tl.title,
      text:           tl.text,
      cancelBtnText:  tl.cancel,
      acceptBtnText:  tl.accept,
      onConfirm: (done) => { // call done() to resolve and dismiss
        axios({
          method: 'DELETE',
          url: requestedUrl,
          data: {format: 'json'},
          headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
        })
        .then((res) => done())
        .catch((error) => console.log(error))
      }
    })

    alert.fire().then((result) => {
      // after result after confirm -> toast + reload
      if(result.wasConfirmed){
        // window.dispatchEvent(new CustomEvent('toast', {
        //   detail: { type: 'notice', message: this.locale.delete.success }
        // }))
        setTimeout(() => window.location.reload(), 500)
      }
    })
  }
}
